import { atom } from 'recoil'
import { CurrentUser } from './type'

export const currentUser = atom<CurrentUser>({
  key: 'currentUser',
  default: new CurrentUser(null, null, null, 'loading', null, false),
})
